import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LabPackageApi } from '../api/labpackage.api';
import { switchMap, map } from 'rxjs/operators';
import { LabPackageData, LabPackage } from '../../../interfaces/masters/labpackage' ;
@Injectable()
export class LabPackageService extends LabPackageData {

    constructor(private api: LabPackageApi) {
      super();
    }
  
  
    list(url: string): Observable<LabPackage[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<LabPackage>{
        return this.api.getById(url);
    }
  
    create(url: string, data:LabPackage): Observable<LabPackage[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:LabPackage): Observable<LabPackage> {
      return this.api.update(url,data);
    }
  
    createList(url: string, data:any): Observable<any> {
      return this.api.addList(url,data);
    }
  
    updateList(url: string, data:any): Observable<any> {
      return this.api.editList(url,data);
    }
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  